import img1 from '/static/img/experience/services/dinner/img1.png'
import img2 from '/static/img/experience/services/dinner/img2.png'
import img3 from '/static/img/experience/services/dinner/img3.png'
import img4 from '/static/img/experience/services/dinner/img4.png'
const dinnerList = [
    {
        id:1,
        img:img1,
        title:'local cuisine & comfort food',
        desc:'Meals can be freely selected according to your needs, choosing from local specialties or international cuisine.',
    },
    {
        id:2,
        img:img2,
        title:'dietary preferences & restrictions',
        desc:'We will find out your dietary preferences and restrictions in advance and emphasize food safety to the catering staff in advance to ensure that you enjoy local cuisine that meets your needs.',
    },
    {
        id:3,
        img:img3,
        title:'group meals',
        desc:'Group meals may take the form of first-class restaurants or buffets, depending on the day\'s schedule and the hotel\'s service capabilities, allowing for a more flexible dining experience.',
    },
    {
        id:4,
        img:img4,
        title:'specia dinners',
        desc:'Some itineraries may include dining in special settings, such as enjoying unique Sichuan cuisine at Shuyanfu during a performance. These highlight the culture or traditions of each unique location.',
    }
]
export default {
    dinnerList
}